import React from 'react'
import SideMenu, {menuItems} from '../../components/SideMenu/SideMenu'


import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import './DocTeamHealth.css'

const Commencer = () => {
    const [inactive, setInactive] = useState(false);

    return (
      <>
      			
<div style={{marginTop : "30px"}} >
           <SideMenu
            onCollapse={(inactive) => {
             // console.log(inactive);
              setInactive(inactive);
            }}
          />

          <div className={`container ${inactive ? "inactive" : ""}`}>

            {/* improvememt, not recorded in video, its just looping through menuItems
            instead of hard coding all the routes */}
            {menuItems.map((menu, index) => (
              <>
                <Route key={menu.name} exact={menu.exact} path={menu.to}>
               

                  <p>Scrum team health</p>                     
                  <h1 >Getting started</h1>

                  <h3>1.Installing</h3>

                  <ol>
                    
                    <li >Log into your Confluence instance as an admin.</li>
                    <li>Click the admin dropdown and choose Apps. </li>
                    <li>Locate Scrum team health Gadget.</li>
                    <li>Click Free trial to download and install your app.</li>
                    <li>Click Close in the Installed and ready to go dialog.</li>
                    
                  </ol>     
                                 
                                    
                  <h3>2.Add Scrum team health gadget to Jira dashboard</h3>

                  <ul>
                    <li  >select gadget from Scrum team health gadgets in the Gadgets Directory and click "Add gadget"</li>
                    <img style={{ margin:"10px" , width:"60%"}} src="./assets/addScrumTeam1update.png" alt="img1" width="90%" height="90%"/>                 
                  </ul>

                  <h3>3. Configure Scrum team health options</h3>
                  <ul>
                    <p>there are only three options are required:</p>

                    <li style={{marginLeft:"6%"}}>Select your project from the drop down button</li>
                    <p>You must specify the project you want to check</p>

                    <li style={{marginLeft:"6%"}}>Link title / name</li>
                    <p>provide a name / title to the project "optional"</p>

                    <li style={{marginLeft:"6%"}}>Select the number of sprints</li>
                    <p>Select the number of sprints you want to display on the chart</p>
                    
                    <li style={{marginLeft:"6%"}}>Select the chart type (Optional)</li>
                    <img style={{ margin:"10px"}} src="./assets/configuration.png" alt="img1" width="90%" height="90%"/>                 


                  </ul>  
                  {/*   
                  <button style={{
                    backgroundColor: "green",
                    border: "none",
                    color: "white",
                    padding: "15px 32px",
                    textAlign: "center",
                    textDecoration: "none",
                    display: "inline-block",
                    fontSize: "16px",
                    margin: "4px 2px",
                    cursor: "pointer",
                    borderRadius: "10px",
                  }}>Next</button>
                 */}

                 
                 
  
  
                </Route>
                {menu.subMenus && menu.subMenus.length > 0
                  ? menu.subMenus.map((subMenu, i) => (
                      <Route key={subMenu.name} path={subMenu.to}>
                        <h1>{subMenu.name}</h1>
                      </Route>
                    ))
                  : null}
              </>
            ))}
             
  
            {/* <Switch>
              <Route exact path={"/"}>
                <Dashboard />
              </Route>
              <Route exact path={"/content"}>
                <Content />
              </Route>
              <Route path={"/content/courses"}>
                <Courses />
              </Route>
              <Route path={"/content/videos"}>
                <Videos />
              </Route>
              <Route path={"/design"}>
                <Design />
              </Route>
              <Route exact path={"/content-2"}>
                <Content2 />
              </Route>
              <Route path={"/content-2/courses"}>
                <Courses2 />
              </Route>
              <Route path={"/content-2/videos"}>
                <Videos2 />
              </Route>
              <Route path={"/design-2"}>
                <Design2 />
              </Route>
            </Switch> */}
           
          </div>
</div>
      </>
      
    )
  }
  

export default Commencer
